module.exports = __webpack_public_path__ + "img/th.7cae6eb1.png";